define('pwa/view/controller/contacts/ContactsView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Index page view
     *
     * @class IndexView
     */
    return LayoutView.extend({

        template: '#contact_page_view',

        modelEvents: {
            'change': 'render'
        },

        onDomRefresh: function () {
            this.onShowPage();
        },

        onShowPage: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'contacts'
            });
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.current_url = location.href;
            if(result.whatsapp){
                result.whatsapp_clean = result.whatsapp.replace(/\D/g, '');
            }
            return result;
        }

    });

});
